import { CctvIcon } from './CctvIcon';

/**
 * author: Roberto Graham
 * id 04FF8A0D-0B5F-426B-ABAF-001EAC16559F
 * name cctv
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cctv.svg
 * tags
 * - Home Automation 
 */
export const ClosedCircuitTelevisionIcon = CctvIcon;
export default ClosedCircuitTelevisionIcon